
import { computed, defineComponent } from 'vue';
import { useMainStore } from '@/store/mainStore';
import ProfileService from '@/modules/profile/services/ProfileService';
import { REGISTRATION_STATE } from '@/types/enums';

export default defineComponent({
  setup() {
    const mainStore = useMainStore();
    const userEmail: string | undefined = mainStore.user?.email;

    const emailNotConfirmed = computed(() => REGISTRATION_STATE.CONFIRM_EMAIL === mainStore.user?.registrationState);

    return {
      userEmail,
      emailNotConfirmed,
    };
  },
});

